export const mapIdColumn = (idColumn: string) => {
  let idColumnMapped;
  switch (idColumn) {
    case 'id':
      idColumnMapped = 'ID';
      break;
    case 'productNatureLabel':
      idColumnMapped = 'PRODUCT_NATURE_EN_NAME';
      break;
    case 'startDate':
      idColumnMapped = 'START_DATE';
      break;
    case 'endDate':
      idColumnMapped = 'END_DATE';
      break;
    case 'descriptionEn':
      idColumnMapped = 'DESCRIPTION_EN';
      break;
    case 'productManagerLabel':
      idColumnMapped = 'PRODUCT_MANAGER_UID';
      break;
    default:
      idColumnMapped = '';
  }
  return idColumnMapped;
};
